import { render, staticRenderFns } from "./MessageChat.vue?vue&type=template&id=5257b9ac&scoped=true&"
import script from "./MessageChat.vue?vue&type=script&lang=js&"
export * from "./MessageChat.vue?vue&type=script&lang=js&"
import style0 from "./MessageChat.vue?vue&type=style&index=0&id=5257b9ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257b9ac",
  null
  
)

export default component.exports